<template>
  <div class="info">
    <div class="topicimg" :style="'background-image:url('+info.line_pic+')'"></div>
    <div class="content">
      <div class="f-16 f-w">{{info.name}}</div>
      <div v-html="info.remark" class="f-14 mt-10"></div>
      <!-- <div class="ellipsis-4 f-14 mt-10">{{info.remark}}</div> -->
    </div>
    <div class="activeifo">
      <van-row>
        <van-col span="12">
          <van-cell :title="info.address" :icon="img.local" />
          <van-cell title="已行驶0公里" :icon="img.km" />
          <van-cell v-if="info.start&&info.end" :title="info.start.substring(5,10) +'---'+ info.end.substring(5,10)" :icon="img.days" />
        </van-col>
        <van-col span="12">
          <van-cell :title="info.tianqi" :icon="img.weather" />
          <van-cell :title="info.likes+'人喜欢'" :icon="img.like" />
          <van-cell :title="info.sudu" :icon="img.speed" />
        </van-col>
      </van-row>
    </div>
    <div class="activeflow" v-if="info.trips&&info.trips.length>0">
      <van-steps :active="active" direction="vertical" :active-icon="img.active" inactive-icon="circle" active-color="#969799">
        <van-step v-for="(item,index) in info.trips" :key="'step_' + item.id" v-show="index<num">
          <van-row type="flex" justify="space-between">
            <van-col span="12" class="f-16 ml-20" >
              {{item.title}}
            </van-col>
            <van-col span="12" class="text-r" v-if="item.juli">
              {{item.juli}}KM<van-icon name="arrow" />
            </van-col>
          </van-row>
        </van-step>
      </van-steps>
      <div class="text-c" v-if="info.trips.length>6" :hidden="moreactive">
        <van-button size="small" @click="moreActive">展开</van-button>
      </div>
      <div class="text-c" v-if="info.trips.length>6" :hidden="!moreactive">
        <van-button size="small" @click="lessActive">收起</van-button>
      </div>
    </div>
    <div class="comments">
      <h2><span class="borderleft"></span>全部评论</h2>
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已加载全部"
      @load="onLoad"
      >
      <div slot="loading" class="list-loading">
        <img :src="img.loading" />
      </div>
      <div class="comment">
        <van-row class="btn-bor" gutter="15" v-for="(comment, index) in comments" :key="'commment_' + comment.id">
           <!-- @click="goMy(comment.user.id)" -->
          <van-col span="3">
            <img class="avatar" :src="comment.user && comment.user.headimg_url&&comment.user.headimg_url.substring(0,5)=='https' ? comment.user.headimg_url : img.avatar" />
            
          </van-col>
          <van-col span="21">
            <h3>
              {{ comment.user.user_name }}
              <span class="binbox">
                <img class="binpic" @click="setCommentPraise(index)" :src="comment.is_praise ? img.collect_have : img.collect">
                <span class="sourtime">{{ comment.praise_num }}</span>
              </span>
            </h3>
            <p v-if="comment.content">{{ comment.content }}</p>
            <p class="time">{{ comment.create_time }}
              <span class="c-black" @click="replys(comment.id)"> · 回复
                <span v-if="comment.replys">({{ comment.replys.length }})</span>
              </span>
              <!-- <span v-if="comment.user.id==params.user_id" class="f-r" @click="delComment(comment.id,index)">删除</span> -->
              <span class="f-r" @click="toTip">举报</span>
            </p>
            <div class="replys" v-if="comment.replys">
             <!--  <router-link class="f-12 c-blue" :to="{name: 'LexusActiveComment', params: {id: comment.id,hid:params.hid}}"> -->
              <van-row v-for="(reply,index) in comment.replys" :key="'replys_' + reply.id" v-show="index>2?false:true">
                <van-col span="3">
                  <img class="headimg" :src="reply.user.headimg_url&&reply.user.headimg_url.substring(0,5)=='https' ? reply.user.headimg_url : img.avatar" >
                </van-col>
                <van-col span="21">
                  <span class="f-w" v-if="reply.user">{{ reply.user.user_name }}</span>
                  <span class="pd-5" v-if="reply.reuser">回复</span>
                  <span class="f-w" v-if="reply.reuser">{{ reply.reuser.user_name }} :</span>
                  {{ reply.content }}
                </van-col>
              </van-row>
              <!-- </router-link> -->
            </div>
          </van-col>
        </van-row>
      </div>
    </van-list>
  </div>
  <div @touchstart="touchstart()" class="postoverlay" v-show="overlay"></div>
  <div class="postbottom" id="inputid">
    <van-row>
      <van-col :span="inputnum">
        <van-field v-model="value" @click="inputFocus()" :focus="inputfocus" placeholder="发表评论..." ref="inputTag" />
      </van-col>
      <van-col  v-if="inputshow" class="botright" span="10">
        <van-row>
          <van-col span="8"> 
            <span class="binbox">
              <img class="binpic" :src="img.comment">
              <span class="num" v-if="info.cnums>0">{{info.cnums}}</span>
            </span>
          </van-col>
          <van-col span="10">
            <span class="binbox" @click="Collect(info.is_follow)">
              <img class="binpic" :src="info.is_follow==1?img.collect_have:img.collect">
              <span class="num" v-if="info.likes>0">{{info.likes}}</span>
            </span>
          </van-col>
          <van-col span="6" @click="outrelay(info.name,info.remark,'/lexus/activeinfo/'+info.id,info.line_pic)">
            <span class="binbox">
              <img class="binpic" :src="img.outrelay">
            </span>
          </van-col>
        </van-row>
      </van-col>
      <van-col v-else span="5">
        <van-button color="#605C6B" size="small" @click="post()">发表</van-button>
      </van-col>
    </van-row>
  </div>
  <van-action-sheet v-model="shareshow" :round="false" cancel-text="取消" @cancel="onCancel">
    <van-divider class="divider">分享</van-divider>
    <van-grid :border='false' :column-num="5">
      <!-- <van-grid-item :icon="img.inrelay" /> -->
      <van-grid-item :icon="img.friends" @click="toShare(2)" />
      <van-grid-item :icon="img.wechat" @click="toShare(1)" />
      <!-- <van-grid-item :icon="img.link" />
        <van-grid-item :icon="img.poster" /> -->
      </van-grid>
    </van-action-sheet>
  </div>
</template>
<script>
  import active from '../../../api/lexus/active';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { List, Cell, CellGroup, Row, Col,Step,Steps,Button,Icon,Overlay,Field,ActionSheet,Divider,Grid, GridItem } from "vant";
  export default {
    data () {
      return {
        value:'',
        inputshow:true,
        hid:'',
        overlay:false,
        inputfocus:false,
        inputnum:14,
        rid:'',
        params:{
          user_id:0
        },
        paramsd:{
          page:1,
          size:10,
          user_id:0
        },
        info:'',
        comments: [],
        loading: false,
        finished: false,
        active:0,
        num:5,
        moreactive:false,
        shareshow:false,
        img:{
          pic:require('../../../assets/img/lexus/1.png'),
          local:require('../../../assets/img/lexus/active/local.png'),
          weather:require('../../../assets/img/lexus/active/weather.png'),
          km:require('../../../assets/img/lexus/active/km.png'),
          like: require('../../../assets/img/lexus/active/like.png'),
          days: require('../../../assets/img/lexus/active/days.png'),
          speed: require('../../../assets/img/lexus/active/speed.png'),
          collect: require('../../../assets/img/lexus/collect.png'),
          collect_have: require('../../../assets/img/lexus/collect_have.png'),
          comment: require('../../../assets/img/lexus/comment.png'),
          inrelay: require('../../../assets/img/lexus/inrelay.png'),
          outrelay: require('../../../assets/img/lexus/outrelay.png'),
          active:require('../../../assets/img/lexus/active/active.png'),
          friends: require('../../../assets/img/lexus/friends.png'),
          wechat: require('../../../assets/img/lexus/wechat.png'),
          link: require('../../../assets/img/lexus/link.png'),
          poster: require('../../../assets/img/lexus/poster.png'),
        },
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.hid = this.$route.params.id
      this.getActiveInfo(this.hid)
      this.weburl=process.env.VUE_APP_URL
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      getActiveInfo(id){
        active.getActiveInfo(this.params,id).then(res => {
          if(res.data.state == 1) {
            this.info = res.data.data
            let trips=res.data.data.trips
            if(trips.length>0){
              for(var i=0;i<trips.length;i++){
                if(trips[i].is_start){
                  this.active=i
                }
              }
            }
          }
        })
      },
      toTip() {
        this.$toast.success('举报成功')
      },
      inputFocus(){//点击输入框聚焦
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        this.inputshow=false;
        this.overlay=true;
        this.inputnum=19;
        setTimeout(() => {
          var cc=document.getElementById('inputid');
          cc.scrollIntoViewIfNeeded(true);
        },500);
      },
      replys(rid){//点击回复聚焦
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        this.inputshow=false;
        this.overlay=true;
        this.inputnum=19;
        this.inputfocus=true
        this.$refs.inputTag.focus()
        this.rid=rid
        setTimeout(() => {
          var cc=document.getElementById('inputid');
          cc.scrollIntoViewIfNeeded(true);
        },500);
      },
      touchstart(){//检测触发遮罩层，失去焦点
        this.inputshow=true;
        this.overlay=false;
        this.$refs.inputTag.blur()
        this.inputnum=14;
        this.inputfocus=false
      },
      inputBlur(){//点击失去焦点
        setTimeout(() => {
          this.inputshow=true;
          this.inputnum=14;
        }, 1000);
        this.overlay=false;
        this.inputfocus=false
        this.$refs.inputTag.blur()
      },
      post(){
        let params={
          rid:this.rid,
          hid:this.hid,
          content:this.value
        }
        active.Comment(params).then(res => {
         if(res.data.state == 1) {
          this.inputshow=true;
          this.inputnum=14;
          this.overlay=false;
          this.inputfocus=false
          this.$refs.inputTag.blur()
          this.$toast.success('发表成功')
          this.value=''
          this.finished = false
          this.comments=[]
          this.paramsd.page = 1
        }
      })
      },
      getCommentList(){
        active.getCommentList(this.hid, this.paramsd).then(res => {
          this.comments.push.apply(this.comments, res.data.data.data)
          this.paramsd.page += 1
          this.loading = false
          if(res.data.data.data.length == 0) {
            this.finished = true
          }
        })
      },
      Collect(type){
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        if(type==1){
          var type=2
        }else{
          var type=1
        }
        active.Collect(this.hid, type).then(res => {
          if(type==2){
            this.info.is_follow=0
            this.info.likes=this.info.likes-1
          }else{
            this.info.is_follow=1
            this.info.likes=this.info.likes+1
          }
        })
      },
      setCommentPraise(index){
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        if(this.user) {
          let type = this.comments[index].is_praise ? 2 : 1;
          active.setCommentPraise({cid: this.comments[index].id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.comments[index].is_praise = 1
                this.comments[index].praise_num += 1
                this.$toast.success('点赞成功')
              } else {
                this.comments[index].is_praise = 0
                this.comments[index].praise_num -= 1
                this.$toast.success('取消成功')
              }
            }
          })
        } else {
          this.$toast('请先登录')
          return false
        }
      },
      delComment(id,index){
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        this.$dialog.confirm({
          message: '确定要删除吗？'
        }).then(() => {
         active.delComment(id).then(res => {
          if(res.data.state == 1) {
            this.$toast.success('已删除')
            this.comments.splice(index,1);
          }
        })
       }).catch(() => {});
      },
      moreActive(){
        this.num=100
        this.moreactive=true
      },
      lessActive(){
        this.num=6
        this.moreactive=false
      },
      onCancel(){
        this.actionshow=false
      },
      outrelay(title,content,url,imageUrl){
        this.shareshow=true
        this.sharetitle=title
        this.sharecontent=content
        this.shareurl=this.weburl+url
        if(imageUrl){
          this.shareimageUrl=imageUrl
        }else{
          // this.shareimageUrl=
        }
        
      },
      toShare(type){
        var params={
          type:type,
          title:this.sharetitle,
          content:this.sharecontent,
          url:this.shareurl,
          imageUrl:this.shareimageUrl
        }
        this.shareshow=false
        this.$appService.shareContent(params)
      },
      goMy(id){
        var params={
          url:this.weburl+'/lexus/my/other/'+id+'?source='+this.source ,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      },
      onLoad() {
        this.params.user_id = this.user ? this.user.id : 0
        setTimeout(() => {
          this.getCommentList()
        }, 500);
      },
    },  
    components:{
      [List.name]: List,
      [Cell.name]:Cell,
      [Row.name]: Row,
      [Col.name]: Col,
      [CellGroup.name]:CellGroup,
      [Step.name]:Step,
      [Steps.name]:Steps,
      [Field.name]:Field,
      [Button.name]:Button,
      [Overlay.name]:Overlay,
      [Icon .name]:Icon,
      [ActionSheet.name]:ActionSheet,
      [Divider.name]:Divider,
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
    }
  }
</script>

<style lang="scss">
.info{
  margin-bottom: 50px;
  background-color: #F0F0F0;
  .topicimg{
    width: 100%;
    height: 230px;
    background-size: cover;
  }
  .fallsimg{
    width: 100%;
    height: auto;
  }
  .content{
    padding: 15px;
    background-color: #fff;
    .mt-10{
      margin-top: 10px;
    }
  }
  .activeifo{
    border-top: 1px solid #f8f8f8;
  }
  .activeflow{
    margin-top: 10px;
    background-color: #fff;
    .ml-20{
      margin-left: 20px;
    }
    .van-step{
      height: 30px;
    }
    .van-button{
      padding:0 25px;
      color: #728FC4;
      margin:20px;
      background-color: #F2F6FA;
    }
  }
  .van-cell:not(:last-child)::after{
    border-bottom:none;
  }
  .van-step--vertical:not(:last-child)::after{
    border-bottom-width:0;
  }
  .borderleft{
    margin-right: 10px;
    border-left: 3px solid #3A3A3A;
  }
  .comments {
    background-color: #FFF;
    margin-top: 10px;

    h2 {
      font-size: 13px;
      font-weight: normal;
      padding: 15px 10px;
      border-bottom: 1px solid #EAEAEA;
      margin: 0;
    }
    .comment {
      margin: 0 10px;
      overflow: hidden;
      .van-row {
        padding: 5px 0;
      }
      .btn-bor{
        padding: 10px 0;
        border-bottom: 1px solid #EAEAEA;
      }
      .avatar {
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 1.5px;
      }
      h3 {
        font-size: 15px;
        margin: 8px 0;

        .binbox {
          color: #9A9A9A;
          font-size: 12px;
          float: right;
          font-weight: normal;

          img {
            width: 15px;
            height: 14px;
            margin-right: 11px;
            vertical-align: middle;
          }
          .sourtime{
            vertical-align: middle;
          }
        }
      }
      p {
        font-size: 15px;

        .c-blue {
          font-style: normal;
        }
        &.time {
          font-size: 12px;
          color: #9A9A9A;

          span {
            margin-left: 5px;
          }
        }
      }
      img {
        width: 25px;
        border-radius: 1.5px;
      }
      .replys {
        .van-row {
          font-size: 13px;
        }
        .pd-5{
          padding: 0 5px;
        }

      }
    }
  }
  a{
    color: #3A3A3A;
  }
  .van-popup{
    .van-action-sheet__cancel::before{
      height: 1px;
    }
    .divider{
      margin: 20px 80px;
    }
  }
}
</style>
